import styled from "styled-components";
import { GRAY } from "../constants";

export const HRStyle = styled.hr`
  border: 0.5px solid ${GRAY};
`;
